import axios from "axios";

const CreateCrop = async (payload) => {
  const timestamp = Math.floor(Date.now() / 1000);
  console.log(payload);
  const token = JSON.parse(localStorage.getItem("authentication"));

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const { id, ...restPayload } = payload;

  const updatedPayload = {
    ...restPayload,
    appCropId: "CR" + timestamp,
  };
  console.log(updatedPayload)
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_API}/api/crop/CreateCrop`,
      updatedPayload,
      config
    );
    return { status: 200, payload: data };
    
  } catch (error) {
    console.error("CreateCrop error:", error);
    console.error(payload);
    const status = error?.response?.status || 500;
    return { status, payload: null };
  }
};

export default CreateCrop;
